module.exports = __webpack_public_path__ + "img/Black Modern Minimalist Presentation.78024583.jpg";